import { render, staticRenderFns } from "./RoomForm.vue?vue&type=template&id=4cec9242&scoped=true"
import script from "./RoomForm.vue?vue&type=script&lang=ts"
export * from "./RoomForm.vue?vue&type=script&lang=ts"
import style0 from "./RoomForm.vue?vue&type=style&index=0&id=4cec9242&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec9242",
  null
  
)

export default component.exports